export const GLOBAL_API_LIMIT = 3000;

export const GLOBAL_API_SEARCH_RESULT_LIMIT = 5;

export const GLOBAL_STALE_TIME = 5 * 60 * 1000; // 5 minutes
export const DEVICE_MISSIONS_REFETCH_INTERVAL = 1000; // now: 1 second, before: 60 seconds
export const DEVICE_ERRORS_REFETCH_INTERVAL = 1000; // now: 1 second, before: 60 seconds
export const DEVICE_SCALAR_VALUES_REFETCH_INTERVAL = 5000; // 5 seconds, the bucketed chart queries are heavier
